import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Calendar,
  Menu,
  message,
  Popconfirm,
  Space,
  Spin,
  Table,
} from "antd";
import ModalItemCalendarList from "./modal/modalItemCalendarList";
import { db, storage } from "../firebase/firebase"; // Import Firestore setup
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  onSnapshot,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import ImageUploadModal from "./modal/modalUploadImage";
import { responsiveArray } from "antd/es/_util/responsiveObserver";
import { render } from "@testing-library/react";
import axios from "axios";

export const GalleryPage = (props) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [record, setRecord] = useState();
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "themes"), (snapshot) => {
      const themeData = snapshot.docs.map((doc) => ({
        key: doc.id,
        ...doc.data(),
      }));
      setThemes(themeData);
      setLoading(false);
    });

    return () => unsubscribe(); 
  }, [trigger]);

  const columns = [
    {
      title: "Theme Name",
      dataIndex: "theme",
      key: "theme",
      render: (text, record) => (
        <div style={{ cursor: "pointer" }} onClick={() => onOpen(record)}>
          {record.theme}
        </div>
      ),
    },
    {
      title: "Theme Key",
      dataIndex: "themeKey",
      key: "themeKey",
      responsive: ["md"],
    },
    {
      title: "Image Title",
      dataIndex: "imageTitle",
      key: "imageTitle",
      responsive: ["md"],
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Popconfirm
          title="Are you sure to delete this theme?"
          onConfirm={() => handleDelete(record.key)}
          okText="Yes"
          cancelText="No"
        >
          <Button danger>Delete</Button>
        </Popconfirm>
      ),
    },
  ];

  const onSubmit = () => {
    setVisible(false);
    setTrigger((c) => !c);
    setRecord();
  };

  const onClose = () => {
    setVisible(false);
    setRecord();
  };

  const onOpen = (item) => {
    setRecord(item);
    setVisible(true);
  };

  // ฟังก์ชันลบ Theme
  const handleDelete = async (themeKey) => {
    try {
      await deleteDoc(doc(db, "themes", themeKey));
      message.success("Theme ถูกลบแล้ว!");
    } catch (error) {
      console.error("Error deleting theme:", error);
      message.error("เกิดข้อผิดพลาดในการลบ Theme");
    }
  };

  const healthCheck = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_URL_HEALTH_CHECK);
      if (response.status === 200) {
        message.success("Health check successful!");
      } else {
        message.warning(`Health check returned status: ${response.status}`);
      }
    } catch (error) {
      message.error("Health check failed!");
      console.error("Health check error:", error);
    }
  };

  return (
    <div className="text-center">
      <div className="">
        <div className="row">
          <div
            style={{
              display: "flex",
              paddingBottom: "10px",
              justifyContent: "flex-end",
              flexDirection: "row",
            }}
          >
            <Space>
              <Button
                key={"check"}
                type="primary"
                onClick={() => healthCheck()}
              >
                Health Check
              </Button>
              <Button key={"create"} type="primary" onClick={() => onOpen()}>
                Create Theme
              </Button>
            </Space>
          </div>
          <div>
            <Table
              columns={columns}
              dataSource={themes}
              pagination={false}
              loading={loading}
              bordered
            />
            <ImageUploadModal
              onClose={onClose}
              onSubmit={onSubmit}
              visible={visible}
              record={record}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
